import React, { Fragment, useContext, useRef, useState } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { getAccessToken } from "../../../storage/storage";
import { AiOutlineClose } from "react-icons/ai";
import { useFormik } from "formik";
import axios from "axios";
import toast from "react-hot-toast";
import * as Yup from "yup";
import { ButtonLoader4 } from "../../../components/ButtonLoader";
import Swal from "sweetalert2";

function CompanyModal(props) {
  const {
    isOpenModal,
    setIsOpenModal,
    companyData,
    setUpdated,
    fetchCompanies,
  } = props;
  const token = getAccessToken();
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const [loading, setLoading] = useState(false);
  const cancelButtonRef = useRef(null);

  const handleClose = () => {
    setIsOpenModal(false);
  };

  const initialValues = {
    name: companyData?.name || "",
    company_number: companyData?.company_number || "",
    address_line1: companyData?.address_line1 || "",
    address_line2: companyData?.address_line2 || "",
    city: companyData?.city || "",
    no_of_properties: companyData?.no_of_properties || "",
    country: companyData?.country || "",
    postal_code: companyData?.postal_code || "",
    mobile_number: companyData?.mobile_number || "",
    use_as: companyData?.use_as || "",
    hear_about_us: companyData?.hear_about_us || "",
  };

  const { values, errors, handleChange, handleSubmit, setFieldValue, touched } =
    useFormik({
      initialValues: initialValues,
      enableReinitialize: true,
      onSubmit: async (values, action) => {
        setLoading(true);

        const payload = {
          ...values,
        };

        await axios
          .patch(
            `${BASE_URL}/api/companies/update/${companyData.id}/`,
            payload,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          )
          .then((response) => {
            // toast.success(response.data.message || "Data Updated");
            setLoading(false);
            action.resetForm();
            setUpdated(true);
            setIsOpenModal(false);
            fetchCompanies();
            Swal.fire({
              icon: "success",
              title: response.data.message || "Data Updated",
              timer: 2000,
              showConfirmButton: false,
              position: "center",
            });
          })
          .catch((error) => {
            console.error("Error:", error);
            // toast.error(error.response.data.error);
            Swal.fire({
              icon: "error",
              title: error.response.data.error || "Something went wrong!",
              timer: 2000,
              showConfirmButton: false,
              position: "center",
            });

            setLoading(false);
          });
      },
    });

  return (
    <>
      <Transition.Root show={isOpenModal} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-[99]"
          initialFocus={cancelButtonRef}
          onClose={handleClose}
        >
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>

          <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
            <div className="flex h-full items-center justify-center p-4 text-center xs:p-2">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all md:w-[600px] h-[100vh] w-full flex justify-center items-center">
                  <div className="flex flex-col gap-8 mt-10 justify-center items-center w-full h-full overflow-y-scroll py-10">
                    <div>
                      <AiOutlineClose
                        className="absolute top-2 right-3"
                        onClick={handleClose}
                      />
                    </div>
                    <div className="flex w-full md:flex-row flex-col justify-between gap-5 px-4">
                      <div className="w-full">
                        <label className="font-medium">Name</label>
                        <input
                          type="text"
                          name="name"
                          placeholder="Name"
                          value={values.name}
                          onChange={handleChange}
                          className="mt-2 w-full p-2 border outline-none h-[55px] px-4 rounded-lg"
                        />
                      </div>
                      <div className="w-full">
                        <label className="font-medium">Company number</label>
                        <input
                          type="text"
                          name="company_number"
                          placeholder="Company number"
                          value={values.company_number}
                          onChange={handleChange}
                          className="mt-2 w-full p-2 border outline-none h-[55px] px-4 rounded-lg"
                        />
                      </div>
                    </div>
                    <div className="flex w-full md:flex-row flex-col justify-between gap-5 px-4">
                      <div className="w-full">
                        <label className="font-medium">Address line1</label>
                        <input
                          type="text"
                          name="address_line1"
                          placeholder="Address line1"
                          value={values.address_line1}
                          onChange={handleChange}
                          className="mt-2 w-full p-2 border outline-none h-[55px] px-4 rounded-lg"
                        />
                      </div>
                      <div className="w-full">
                        <label className="font-medium">Address line2</label>
                        <input
                          type="text"
                          name="address_line2"
                          placeholder="Address line2"
                          value={values.address_line2}
                          onChange={handleChange}
                          className="mt-2 w-full p-2 border outline-none h-[55px] px-4 rounded-lg"
                        />
                      </div>
                    </div>
                    <div className="flex w-full md:flex-row flex-col justify-between gap-5 px-4">
                      <div className="w-full">
                        <label className="font-medium">City</label>
                        <input
                          type="text"
                          name="city"
                          placeholder="City"
                          value={values.city}
                          onChange={handleChange}
                          className="mt-2 w-full p-2 border outline-none h-[55px] px-4 rounded-lg"
                        />
                      </div>
                      <div className="w-full">
                        <label className="font-medium">No of properties</label>
                        <input
                          type="text"
                          name="no_of_properties"
                          placeholder="No of properties"
                          value={values.no_of_properties}
                          onChange={handleChange}
                          className="mt-2 w-full p-2 border outline-none h-[55px] px-4 rounded-lg"
                        />
                      </div>
                    </div>
                    <div className="flex w-full md:flex-row flex-col justify-between gap-5 px-4">
                      <div className="w-full">
                        <label className="font-medium">Country</label>
                        <input
                          type="text"
                          name="country"
                          placeholder="Country"
                          value={values.country}
                          onChange={handleChange}
                          className="mt-2 w-full p-2 border outline-none h-[55px] px-4 rounded-lg"
                        />
                      </div>
                      <div className="w-full">
                        <label className="font-medium">Postal code</label>
                        <input
                          type="text"
                          name="postal_code"
                          placeholder="Postal code"
                          value={values.postal_code}
                          onChange={handleChange}
                          className="mt-2 w-full p-2 border outline-none h-[55px] px-4 rounded-lg"
                        />
                      </div>
                    </div>
                    <div className="flex w-full md:flex-row flex-col justify-between gap-5 px-4">
                      <div className="w-full">
                        <label className="font-medium">Mobile number</label>
                        <input
                          type="text"
                          name="mobile_number"
                          placeholder="Mobile number"
                          value={values.mobile_number}
                          onChange={handleChange}
                          className="mt-2 w-full p-2 border outline-none h-[55px] px-4 rounded-lg"
                        />
                      </div>
                      <div className="w-full">
                        <label className="font-medium">
                          Property Management System
                        </label>
                        <input
                          type="text"
                          name="use_as"
                          placeholder="Use as"
                          value={values.use_as}
                          onChange={handleChange}
                          className="mt-2 w-full p-2 border outline-none h-[55px] px-4 rounded-lg"
                        />
                      </div>
                    </div>
                    <div className="flex w-full flex-col px-4">
                      <label className="font-medium">Hear about us</label>
                      <input
                        type="text"
                        name="hear_about_us"
                        placeholder="Hear about us"
                        value={values.hear_about_us}
                        onChange={handleChange}
                        className="mt-2 w-full p-2 border outline-none h-[55px] px-4 rounded-lg"
                      />
                    </div>
                    <div className="w-full flex justify-end px-4">
                      <button
                        onClick={handleSubmit}
                        type="submit"
                        className="mt-0 w-[100px] bg-[#586989] text-white h-[40px] rounded"
                      >
                        {loading ? <ButtonLoader4 /> : "Update"}
                      </button>
                    </div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition.Root>
    </>
  );
}

export default CompanyModal;
